if (!window.collectionCustomAjaxReady) {
  window.collectionCustomAjaxReady = true;

  document.addEventListener('submit', async (event) => {
    const form = event.target.closest('.collectionCustomForm');
    if (!form || typeof addProduct !== 'function') return;

    event.preventDefault();
    const button = form.querySelector('button[type="submit"]');
    const variantId = form.querySelector('[name="id"]');
    const sellingPlan = form.querySelector('[name="selling_plan"]');
    if (!variantId || !button || button.disabled) return;

    const item = { id: Number(variantId.value), quantity: 1 };
    if (sellingPlan) item.selling_plan = Number(sellingPlan.value);

    button.disabled = true;
    button.classList.add('loading');

    try {
      const result = await addProduct({ items: [item] });
      if (result.status) throw new Error(result.description || 'Unable to add this product.');
      if (typeof openCart === 'function') await openCart();
    } catch (error) {
      window.alert(error.message);
    } finally {
      button.disabled = false;
      button.classList.remove('loading');
    }
  });
}
